import React, { useMemo } from 'react';

import { ApiOrder } from '#/api/types';
import { useSelector } from '#/reduxState/storeCore';

import TPSLColumn from './TPSLColumn';
import { findTpSlOrders } from './tpSlUtils';

/** Desktop and Mobile TP/SL Column (Block) */
export default function TPSLColumWrap({
  market,
  allOrders,
  tickSizeDecimals,
  onEdit,
}: {
  market: string | undefined;
  allOrders: ApiOrder[] | undefined;
  tickSizeDecimals: number | undefined;
  onEdit: () => void;
}) {
  const maximumPositionSizes = useSelector(
    state => state.markets.listedMarkets.maximumPositionSizes
  );
  const { stopLossOrder, takeProfitOrder } = useMemo(
    () =>
      market
        ? findTpSlOrders({
            allOrders,
            market,
            maximumPositionSizes,
          })
        : { stopLossOrder: undefined, takeProfitOrder: undefined },
    [allOrders, market, maximumPositionSizes]
  );
  if (!market) {
    return <>-</>;
  }
  return (
    <TPSLColumn
      onEdit={onEdit}
      stopLossPrice={stopLossOrder?.triggerPrice}
      takeProfitPrice={takeProfitOrder?.triggerPrice}
      tickSizeDecimals={tickSizeDecimals}
    />
  );
}
